// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.YT = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.YT = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var YT = _exports.YT = function YT(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14254)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.4441 16.8675L6.35278 16.7926C5.02809 16.7666 3.7001 16.8186 2.40138 16.5485C0.425734 16.1449 0.285772 14.1659 0.139317 12.506C-0.062484 10.1723 0.015639 7.79622 0.396463 5.48201C0.61145 4.18349 1.45751 3.40866 2.76592 3.32434C7.18276 3.01834 11.629 3.05461 16.036 3.19737C16.5014 3.21045 16.9701 3.28198 17.429 3.3634C19.6945 3.76051 19.7497 6.00309 19.8966 7.89093C20.043 9.79824 19.9812 11.7154 19.7013 13.6097C19.4767 15.1781 19.047 16.4934 17.2337 16.6204C14.9618 16.7864 12.742 16.9201 10.4636 16.8775C10.4637 16.8675 10.4506 16.8675 10.4441 16.8675ZM8.03881 12.8966C9.75092 11.9136 11.4304 10.9469 13.1327 9.97047C11.4174 8.98745 9.74113 8.0208 8.03881 7.04437V12.8966Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14254"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
